module.exports = __webpack_public_path__ + "static/media/bg-image-4.fb8e3405.jpg";